module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "part01"
    }
  }), _vm._v("PART ONE")]), _vm._v(" "), _c('h2', {
    staticClass: "h2a"
  }, [_vm._v("AND A DARKNESS"), _c('br'), _vm._v("OVER THE EARTH")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Soul that rises with us, our life’s Star,"), _c('br'), _vm._v("Hath had elsewhere its setting"), _c('br'), _vm._v("And cometh from afar;"), _c('br'), _vm._v("Not in entire forgetfulness,"), _c('br'), _vm._v("And not in utter nakedness,"), _c('br'), _vm._v("But trailing clouds of glory do we come"), _c('br'), _vm._v("From God, who is our home.")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("—"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WILLIAM WORDSWORTH")]), _c('br'), _vm._v("“Ode on Intimations of Immortality from"), _c('br'), _vm._v("Recollections of Early Childhood”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("There is no supernatural. There is only the natural"), _c('br'), _vm._v("world, and you have access to all of it. Souls are part of"), _c('br'), _vm._v("nature.")]), _vm._v(" "), _c('p', {
    staticClass: "right-para1"
  }, [_vm._v("—The Master of the Key")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2b3892","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01.vue
// module id = 81
// module chunks = 0